const getters = {
  listMenus: state => {
    let menuList = []
    Object.keys(state.menus).forEach(key => {
      menuList.push(state.menus[key]);
    })
    return menuList;
  },
};

export default getters;